// extracted by mini-css-extract-plugin
export default {"update-cart-quantities__button":"update-cart-quantities__button_tIqJk0Ho"};